<div class="container my-5">

    <header class="text-center mb-5">
        <h1 class="display-4">We're Hiring: Back-End Engineer</h1>
        <p class="lead">Join our team and help build scalable and reliable server-side systems!</p>
    </header>

    <section class="mb-5">
        <h2>About the Role</h2>
        <p>
            We are looking for an experienced and enthusiastic <strong>Back-End Engineer</strong> to join our
            talented development team. In this role, you’ll be responsible for designing, building, and
            maintaining the core functionality of our applications and systems.
        </p>
    </section>

    <section class="mb-5">
        <h2>Responsibilities</h2>
        <ul>
            <li>Develop, test, and maintain server-side logic and APIs.</li>
            <li>Collaborate with front-end developers to integrate user-facing elements with server-side logic.</li>
            <li>Ensure the scalability, performance, and reliability of applications.</li>
            <li>Design and implement data storage solutions using SQL or NoSQL databases.</li>
            <li>Write clean, maintainable, and well-documented code.</li>
            <li>Monitor and debug production systems to ensure stability.</li>
            <li>Stay updated with the latest back-end technologies and best practices.</li>
        </ul>
    </section>

    <section class="mb-5">
        <h2>Qualifications</h2>
        <ul>
            <li>Proven experience as a Back-End Engineer or similar role.</li>
            <li>Proficiency in programming languages such as Python, Node.js, Java, or Ruby.</li>
            <li>Experience with RESTful APIs and microservices architecture.</li>
            <li>Strong understanding of databases (SQL/NoSQL) and data modeling.</li>
            <li>Familiarity with containerization tools like Docker and orchestration tools like Kubernetes.</li>
            <li>Knowledge of version control systems such as Git.</li>
            <li>Strong problem-solving skills and a focus on delivering efficient solutions.</li>
        </ul>
    </section>

    <section class="mb-5">
        <h2>Nice-to-Haves</h2>
        <ul>
            <li>Experience with cloud platforms like AWS, Azure, or Google Cloud.</li>
            <li>Familiarity with CI/CD pipelines.</li>
            <li>Knowledge of GraphQL and WebSocket-based communication.</li>
        </ul>
    </section>

    <section class="mb-5">
        <h2>Benefits</h2>
        <ul>
            <li>Competitive salary and performance-based bonuses.</li>
            <li>Comprehensive health, dental, and vision insurance.</li>
            <li>Flexible working hours and remote work options.</li>
            <li>Opportunities for professional growth and learning.</li>
            <li>Collaborative and innovative work environment.</li>
        </ul>
    </section>
    <!--
        <section class="text-center">
            <h2>How to Apply</h2>
            <p>
                Ready to take the next step? Send your resume and any relevant work samples to
                <a href="mailto:careers@yourcompany.com">careers@yourcompany.com</a>.
                Don’t forget to include a cover letter explaining your interest in the role.
            </p>
            <a href="mailto:careers@yourcompany.com" class="btn btn-primary btn-lg">Apply Now</a>
        </section>
        -->
</div>
